<script>
import Card from "@/pages/components/card.vue";
import {router, useForm} from "@inertiajs/vue3";
import FormElements from "@wielink-application/shared/js/mixins/formElements";

export default {
  mixins: [FormElements],
  components: {Card},
  props: {
    twoFaEnabled: {
      type: Boolean,
      required: true,
    },
    qrImage: {
      type: String,
      required: true,
    },
    secret: {
      type: String,
      required: true,
    },
    showTitle: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      form: useForm({
        'secret': '',
        'auth_code_verify': ''
      })
    }
  },
  mounted() {
    this.form.defaults({
      secret: this.secret
    });
    this.form.reset();
  },
  methods: {
    submit() {
      let url = this.twoFaEnabled ? route('profile.2fa.disable') : route('profile.2fa.enable');

      $.ajax({
        url: url,
        method: 'POST',
        data: this.form.data(),
        success: (response) => {
          router.reload();
        },
        error: (response) => {
          this.form.errors['auth_code_verify'] = response.responseJSON.message;
        }
      });
    }
  }
}
</script>

<template>
  <form @submit.prevent="submit">
    <h2 v-if="showTitle" class="card-title">Twee staps authenticatie (2FA)</h2>

    <p>
      Stel de 2 staps authenticatie in door onderstaande code te scannen. Als alternatief voor scannen kunt u de volgende secret in uw app invoeren:
      <b>{{ secret }}</b>
    </p>

    <img class="border mb-4" :src="qrImage" :alt="secret">

    <div v-if="!twoFaEnabled">
      <Input v-model="form.auth_code_verify" :form="form" name="auth_code_verify" label="Code" required placeholder="000000"/>
      <button class="btn btn-primary">Inschakelen</button>
    </div>

    <div v-if="twoFaEnabled">
      <p>Uw 2FA is actief, als u uw code bent verloren of deze wilt wijzigen druk dan op de onderstaande knop</p>

      <button class="btn btn-danger">Uitschakelen</button>
    </div>
  </form>
</template>